import { Modal } from "react-bootstrap";
import { useDeleteGoalMutation } from "../goalsApi";
import Button from "app/storybookComponents/Button";

interface Props {
  isOpen: boolean;
  hideModal: () => void;
  goalId: number | null;
}

export default function DeleteGoalModal({
  isOpen,
  hideModal,
  goalId,
}: Readonly<Props>) {
  const [deleteGoal, { isLoading: isDeleting }] = useDeleteGoalMutation();

  const onDelete = async () => {
    if (!goalId) return;

    await deleteGoal({ goalId }).unwrap();
    hideModal();
  };

  return (
    <Modal
      show={isOpen}
      onHide={hideModal}
      centered
      size="lg"
      backdrop="static"
    >
      <div className="goal-modal">
        {/* ---------------- HEADER ---------------- */}
        <div className="gm-header p-3 pb-0">
          <h2>Delete Goal</h2>

          {/* Close Button */}
          <Button
            onClick={hideModal}
            variant="secondary-blue"
            xIcon
            style={{ border: "none" }}
          />
        </div>

        {/* ---------------- MESSAGE BLOCK ---------------- */}
        <div className="delete-msg-wrap">
          <div className="delete-title">
            Are you sure you want to delete this goal?
          </div>

          <div className="delete-desc">
            This goal and any reflections saved will be deleted. This action
            cannot be undone.
          </div>
        </div>

        {/* ---------------- FOOTER BUTTONS ---------------- */}
        <div className="delete-btn-row">
          <button className="btn-cancel" onClick={hideModal}>
            Cancel
          </button>

          <button
            className="btn-delete"
            onClick={onDelete}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete goal"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
